module.exports = __webpack_public_path__ + "media/components/tweets/static/compose-a2d2801fa74771b30f69f48531a8070b.svg";